module.exports = __webpack_public_path__ + "static/media/BM.822c18f6.svg";